import axios from 'axios';
import { baseApi, token } from '../../../services/Apis';

export const tiposContactosApi = `${baseApi}/contact-types`;

export const getAllTiposContactosService = async (params) => {
  const res = await axios.get(tiposContactosApi, {
    headers: await token({}),
    params,
  });
  return res;
};

export const saveTiposContactosService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.put(`${tiposContactosApi}/${id}`, data, {
      headers: await token({}),
    });
  } else {
    res = await axios.post(`${tiposContactosApi}`, data, {
      headers: await token({}),
    });
  }
  return res.data;
};

export const getOneTiposContactosService = async (id) => {
  const res = await axios.get(`${tiposContactosApi}/${id}`, {
    headers: await token({}),
  });
  return res;
};

export const deleteTiposContactosService = async (id) => {
  const res = await axios.delete(`${tiposContactosApi}/${id}`, {
    headers: await token({}),
  });
  return res;
};
